export enum LockerType {
    Regular = 'Regular',
    Refrigerated = 'Refrigerated',
    HighSecurity = 'High-Security'
  }